import { registerRealtime as registerRealtimeOrigin } from '@cloudbase/realtime';
import { ICloudbase } from '@cloudbase/types';

export const registerRealtime = registerRealtimeOrigin as (app: ICloudbase) => void;

try {
  (window as any).registerRealtime = registerRealtime
} catch (e) {}